export default __webpack_public_path__ + "static/media/repuesto-critico.cfe9190f.svg";